interface HeaderInputProps {
  label?: string;
}

const HeaderInput = ({ label }: HeaderInputProps) => {
  if (!label) return null;

  return (
    <div className="w-full py-3 px-4 bg-gradient-to-r from-[#C0275E]/10 to-[#C0275E]/5 border-l-4 border-[#C0275E] rounded-r-lg">
      <h2 className="text-sm font-bold text-[#C0275E] uppercase tracking-wide">{label}</h2>
    </div>
  );
};

export default HeaderInput;
